import { Component, OnInit } from '@angular/core';
import { GatewaySetupService, CreatedGateway } from '../gateway-setup.service';
import { ConfigService } from '../../core/config.service';
import { Location } from '../../locations/location.service';

export interface CreateBody {
  deviceUuid: string;
  locationId: string;
  description: string;
}

@Component({
  selector: 'app-gateway-create',
  templateUrl: './gateway-create.component.html',
  styleUrls: ['./gateway-create.component.scss']
})
export class GatewayCreateComponent implements OnInit {
  locations: Array<Location>;
  applications: Array<{
    application_id: string;
    application_name: string;
  }>;
  gateways: Array<CreatedGateway>;

  isLoading = true;
  isInProgress = false;
  description = '';
  deviceUuid: string = null;
  parentApplication: string = null;
  downloadLink: string = null;
  locationId: string = null;
  errorMessage = '';

  STATUSES = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR'
  };

  constructor(private gatewaySetupService: GatewaySetupService, private config: ConfigService) {}

  async ngOnInit() {
    try {
      await Promise.all([this.fetchLocations(), this.fetchApplications(), this.fetchGateways()]);
      this.isLoading = false;
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }

  public async fetchGateways() {
    this.gateways = await this.gatewaySetupService.getGatewaysRaw();
  }

  // for now only one application per environment, i.e. can only set up prod on prod, test on test
  private async fetchApplications() {
    const application_name = this.config.getConfig('stage');
    let application_id;

    switch (application_name) {
      case 'ycy':
        application_id = 'SensorflowYcyApp';
        break;
      case 'production':
        application_id = 'SensorflowProdApp';
        break;
      case 'test':
        application_id = 'SensorflowTestApp';
        break;
      default:
        application_id = 'Not found';
    }

    this.applications = await Promise.resolve([
      {
        application_id,
        application_name
      }
    ]);
  }

  private async fetchLocations() {
    // TODO: when we add create locations, have to peform a re-pull and update locationService
    // get locations that the user can see
    this.locations = JSON.parse(localStorage.getItem('locations'));
  }

  async createGateway() {
    this.isInProgress = true;
    // clear any traces of previous create operations
    this.downloadLink = null;
    this.errorMessage = null;

    try {
      if (!(this.parentApplication && this.locationId && this.description)) {
        throw new Error(`Device needs a parent application, location and description`);
      }
      const createBody: CreateBody = {
        deviceUuid: this.deviceUuid,
        locationId: this.locationId,
        description: this.description
      };

      const createResult = await this.gatewaySetupService.createGateway(createBody);
      this.handleCreateResult(createResult);
    } catch (error) {
      console.error(`Error creating gateway: ${error.message}`);
      this.resetCreateState();
      this.errorMessage = error.message;
    }
  }

  private handleCreateResult(createResult) {
    const { deviceUuid, status, downloadLink, error } = createResult;

    // TODO: can clean up to check only status or error message, consider switch case as well
    if (status === this.STATUSES.ERROR && error) {
      throw new Error(error);
    } else if (status === this.STATUSES.IN_PROGRESS || status === this.STATUSES.PENDING) {
      this.deviceUuid = deviceUuid;
      setTimeout(() => {
        this.createGateway();
      }, 20 * 1000); // retry after 20 seconds
    } else if (status === this.STATUSES.COMPLETE) {
      if (downloadLink) {
        this.resetCreateState();
        this.downloadLink = downloadLink;
      } else {
        throw new Error(`Error in the response, result is ${createResult}`);
      }
    } else {
      throw new Error(`Invalid status.`);
    }
  }

  private resetCreateState() {
    this.isInProgress = false;
    this.description = '';
    this.parentApplication = null;
    this.locationId = null;
    this.deviceUuid = null;
    this.downloadLink = null;
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-setup/gateway-create/gateway-create.component.ts